import { render, staticRenderFns } from "./IconDown.vue?vue&type=template&id=5c3fd202"
import script from "./IconDown.vue?vue&type=script&lang=js"
export * from "./IconDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports